namespace GeniuzPOS.InitialData {
    export interface PsDiscCouponTypeSerialForm {
        DiscCouponType: Serenity.StringEditor;
        Serial: Serenity.StringEditor;
        CreateBy: Serenity.StringEditor;
        CreateDate: Serenity.DateEditor;
        Used: Serenity.IntegerEditor;
        IsActive: Serenity.IntegerEditor;
    }

    export class PsDiscCouponTypeSerialForm extends Serenity.PrefixedContext {
        static formKey = 'InitialData.PsDiscCouponTypeSerial';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsDiscCouponTypeSerialForm.init)  {
                PsDiscCouponTypeSerialForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.IntegerEditor;

                Q.initFormType(PsDiscCouponTypeSerialForm, [
                    'DiscCouponType', w0,
                    'Serial', w0,
                    'CreateBy', w0,
                    'CreateDate', w1,
                    'Used', w2,
                    'IsActive', w2
                ]);
            }
        }
    }
}
